'use client';

import { DynamicTextStoryblok } from '@/storyblok/types';
import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { DynamicTextRichTextRenderer } from './richTextRenderer';
import { StoryblokReactComponent } from '@/storyblok/components/componentsMap';
import { monaFont } from '@/styles/fonts';

const CHANGE_INTERVAL = 3000;

export const StoryblokDynamicText: StoryblokReactComponent<DynamicTextStoryblok> = ({
  component: { values: valuesTxt, beforeText, accentColor },
}) => {
  const values = valuesTxt.split(',').map(title => title.trim());
  const [currentTitle, setCurrentTitle] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      setCurrentTitle((currentTitle + 1) % values.length);
    }, CHANGE_INTERVAL);
  }, [currentTitle, values.length]);

  if (values.length === 0) {
    return null;
  }

  return (
    <DynamicTextRichTextRenderer richText={beforeText}>
      <ul className="relative ml-1 inline-block">
        {values.map((value, i) => (
          <li
            key={i}
            className={clsx(
              monaFont.className,
              'whitespace-nowrap transition-opacity  duration-500',
              i !== 0 && 'absolute left-0 top-0',
              i === currentTitle ? 'opacity-100' : 'opacity-0',
              accentColor === 'brandBlue' ? 'text-brandBlue-400' : 'text-elty-green',
            )}
          >
            {value}
          </li>
        ))}
      </ul>
    </DynamicTextRichTextRenderer>
  );
};
